import { isNil } from "@clipboard-health/util-ts";
import { Input, type InputRef } from "antd";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect, useRef } from "react";

import { getLocationFromPlace, getMapApi, parseAddressComponents } from "../../utils/googleMap";

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'props' implicitly has an 'any' type.
function PlacesAutoComplete(props) {
  const { defaultValue, onChange, value, refresh } = props;
  const searchInput = useRef<InputRef>(null);

  useEffect(() => {
    let autoComplete: google.maps.places.Autocomplete | undefined;
    let autoCompleteListener: google.maps.MapsEventListener | undefined;
    let isMounted = true;

    const initAutoSearch = async () => {
      const mapApi = await getMapApi();

      const searchInputCurrent = searchInput.current;
      if (!isMounted || isNil(searchInputCurrent)) {
        return;
      }

      const { input } = searchInputCurrent;
      if (isNil(input)) {
        return;
      }

      const nextAutoComplete = new mapApi.places.Autocomplete(input);
      autoComplete = nextAutoComplete;
      autoCompleteListener = nextAutoComplete.addListener("place_changed", onPlaceChanged);

      input.focus();
    };

    const onPlaceChanged = () => {
      if (isNil(autoComplete)) {
        return;
      }

      const place = autoComplete.getPlace();

      if (isNil(place.geometry)) {
        return;
      }

      const location = getLocationFromPlace(place);
      const address = parseAddressComponents(place.address_components ?? []);

      address.formatted = place.formatted_address;
      onChange({ location, address });
    };

    void initAutoSearch();

    return () => {
      isMounted = false;
      autoCompleteListener?.remove();
    };
  }, [onChange]);

  useEffect(() => {
    const input = searchInput.current?.input;
    if (isNil(input)) {
      return;
    }

    input.focus();
  }, [refresh]);

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'e' implicitly has an 'any' type.
  const onInputChange = (e) => {
    const { value: val } = e.target;
    if (!val || val.length === 0) {
      onChange(null);
    }
  };

  return (
    <Input
      placeholder="Search for area, street name..."
      ref={searchInput}
      allowClear
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
      value={value}
      style={{ maxWidth: "400px" }}
      defaultValue={defaultValue}
      onChange={onInputChange}
    />
  );
}

export { PlacesAutoComplete };
